export const INCREMENT_CURRENT_ROUND = 'INCREMENT_CURRENT_ROUND';

export const incrementCurrentRound = () => ({
    type: INCREMENT_CURRENT_ROUND
});
